interface Props {
  num: string;
  eyebrow: string;
  title: string;
  dek?: string;
}

export function SectionHead({ num, eyebrow, title, dek }: Props) {
  return (
    <div className="md-section__head reveal">
      <div className="md-section__eyebrow md-label-l">
        <span className="md-section__num md-label-m">{num}</span>
        {eyebrow}
      </div>
      <h2 className="md-headline-l" style={{ margin: 0 }}>{title}</h2>
      {dek && <p className="md-body-l md-section__dek">{dek}</p>}
    </div>
  );
}
